import type { ThemeConfig } from 'antd';

export const themeConfig: ThemeConfig = {
  token: {
    colorPrimary: '#1677ff',
    colorBgBase: '#ffffff',
    colorBgLayout: '#f3f6fb',
    colorBgContainer: '#ffffff',
    colorBgElevated: '#ffffff',
    colorBorder: '#e7edf5',
    colorBorderSecondary: '#eef2f7',
    colorText: '#0f172a',
    colorTextSecondary: '#64748b',
    colorTextTertiary: '#94a3b8',
    colorSplit: '#eef2f7',
    borderRadius: 12,
    borderRadiusLG: 16,
    borderRadiusSM: 8,
    fontFamily:
      "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontSize: 14,
    controlHeight: 40,
    controlHeightLG: 48,
    controlHeightSM: 32,
    colorSuccess: '#16a34a',
    colorWarning: '#f59e0b',
    colorError: '#ef4444',
    colorInfo: '#1677ff',
    boxShadow:
      '0 1px 2px rgba(15, 23, 42, 0.04), 0 8px 24px -12px rgba(15, 23, 42, 0.12)',
    boxShadowSecondary:
      '0 10px 40px -12px rgba(15, 23, 42, 0.18), 0 4px 12px rgba(15, 23, 42, 0.06)',
  },
  components: {
    Layout: {
      siderBg: '#07111f',
      bodyBg: '#f3f6fb',
      headerBg: 'transparent',
    },
    Menu: {
      darkItemBg: 'transparent',
      darkItemSelectedBg: 'transparent',
      darkSubMenuItemBg: 'transparent',
      darkItemColor: '#8ba0b8',
      darkItemHoverColor: '#ffffff',
      darkItemSelectedColor: '#ffffff',
      darkItemHoverBg: 'rgba(255,255,255,0.06)',
      itemHeight: 42,
      itemBorderRadius: 12,
      itemMarginInline: 10,
    },
    Card: {
      borderRadiusLG: 16,
      paddingLG: 20,
    },
    Button: {
      controlHeight: 40,
      controlHeightLG: 46,
      borderRadius: 10,
      borderRadiusLG: 12,
      fontWeight: 600,
      primaryShadow: '0 6px 16px -6px rgba(22,119,255,0.5)',
    },
    Input: {
      controlHeight: 42,
      controlHeightLG: 48,
      borderRadius: 12,
      activeShadow: '0 0 0 3px rgba(22,119,255,0.12)',
    },
    Select: {
      controlHeight: 42,
      borderRadius: 12,
    },
    Table: {
      borderRadius: 16,
      headerBg: '#f8fafc',
      headerColor: '#64748b',
      headerSplitColor: 'transparent',
      rowHoverBg: '#f5f8ff',
      cellPaddingBlock: 14,
      cellPaddingInline: 16,
    },
    Modal: {
      borderRadiusLG: 20,
      paddingContentHorizontalLG: 24,
    },
    Tag: {
      borderRadiusSM: 999,
      fontSizeSM: 12,
    },
    Tabs: {
      itemColor: '#64748b',
      itemSelectedColor: '#1677ff',
      itemHoverColor: '#0f172a',
      inkBarColor: '#1677ff',
      titleFontSize: 14,
    },
    Tooltip: {
      borderRadius: 10,
    },
    Dropdown: {
      borderRadiusLG: 14,
      paddingBlock: 6,
    },
    Pagination: {
      itemActiveBg: '#1677ff',
      borderRadius: 8,
    },
    Segmented: {
      borderRadius: 10,
      itemSelectedBg: '#ffffff',
    },
  },
};

export const SIDEBAR_WIDTH = 260;
export const SIDEBAR_COLLAPSED_WIDTH = 72;
export const HEADER_HEIGHT = 64;
